import React, { useContext, useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import TextField from '../../components/common/TextField';
import Button from '../../components/common/Button';
import Typography from '../../components/common/Typography';
import { formatPhoneNumber, formatTime } from '../../common/Util';
import { getSMSAuthNumber, getSmsLoginCheck } from './loginSlice';
import AlertContext from '../../context/AlertContext';
import { useDispatch } from 'react-redux';
import SMSList from './SMSList';

const SMSLogin = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation('login');
  const {
    alertActions: { alertMessage },
  } = useContext(AlertContext);
  const [time, setTime] = useState(0);
  const [form, setForm] = useState({
    htmBirthDay: '',
    htmInsaPerHTel: '',
    htmAuth: '',
  });
  const [SMSListData, setSMSListData] = useState([]);
  const [SMSListOpen, setSMSListOpen] = useState(false);

  const intervalRef = useRef(null);

  useEffect(() => {
    if (time === 0) return;
    intervalRef.current = setInterval(() => {
      setTime(prevTime => prevTime - 1);
    }, 1000);

    return () => clearInterval(intervalRef.current);
  }, [time]);

  const handleSmsLogin = async () => {
    if (time === 0) {
      // 인증번호 만료
      alertMessage(t('alertMessage05'));
      return;
    }

    if (form.htmAuth === '') {
      // 인증번호 입력
      alertMessage(t('alertMessage04'));
      return;
    }

    // 로그인
    try {
      const response = await dispatch(
        getSmsLoginCheck({
          htmPhone: form.htmInsaPerHTel,
          htmAuth: form.htmAuth,
        }),
      ).unwrap();

      if (response.setLogin === 'true') {
        clearInterval(intervalRef.current); // 인터벌 중지
        setTime(0); //타이머 초기화
        if (response.diff > 300) {
          // 유효시간 초과
          alertMessage(t('alertMessage06'));
          return;
        }

        setSMSListOpen(true);
        return;
      }
    } catch (error) {
      // 에러 처리 로직 추가 가능
    }
  };

  const handleSmsSend = async () => {
    if (form.htmBirthDay === '' || form.htmInsaPerHTel === '') {
      alertMessage(t('alertMessage01'));
      return;
    }
    try {
      const response = await dispatch(
        getSMSAuthNumber({
          htmBirthDay: form.htmBirthDay,
          htmInsaPerHTel: form.htmInsaPerHTel,
        }),
      ).unwrap();

      if (response.loginMsg === '0') {
        // 정보를 찾을 수 없습니다.
        alertMessage(t('alertMessage02'));
        return;
      }

      // 인증번호가 전송되었습니다.
      alertMessage(t('alertMessage03'));
      setTime(120);
      setSMSListData(response.list);
    } catch (error) {
      // 에러 처리 로직 추가 가능
    }
  };

  const handleChange = e => {
    const { name, value } = e.target;
    let _value = value.replace(/[^0-9]/g, '');
    if (name === 'htmInsaPerHTel') {
      _value = _value.slice(0, 11);
      setForm({ ...form, [name]: _value });
      return;
    }

    if (name === 'htmAuth') {
      _value = value.replace(/[^0-9]/g, '');
      setForm({ ...form, [name]: _value });
      return;
    }

    _value = value.slice(0, 6);
    console.log(_value);
    setForm({ ...form, [name]: _value });
  };

  return (
    <div className="displayFlexColumn" style={{ gap: '10px' }}>
      <TextField
        placeholder={t('birth')}
        variant="login"
        size="large"
        name="htmBirthDay"
        value={form.htmBirthDay}
        onChange={handleChange}
      />
      <div className="displayFlex" style={{ gap: '10px' }}>
        <TextField
          placeholder={t('phone')}
          variant="login"
          size="large"
          style={{ flex: 1 }}
          name="htmInsaPerHTel"
          value={formatPhoneNumber(form.htmInsaPerHTel)}
          onChange={handleChange}
        />
        <Button size="medium" value={t('authButton')} color="sub" onClick={handleSmsSend} />
      </div>
      <TextField
        placeholder={t('auth')}
        variant="login"
        size="large"
        name="htmAuth"
        value={form.htmAuth}
        onChange={handleChange}
      />
      {time !== 0 && (
        <Typography variant="captionMedium" textAlign="right">
          {formatTime(time)}
        </Typography>
      )}
      <Button size="large" value={t('loginButton')} onClick={handleSmsLogin} />

      {SMSListOpen && (
        <SMSList onClose={() => setSMSListOpen(false)} data={SMSListData} form={form} />
      )}
    </div>
  );
};

export default SMSLogin;
